import {formatSubjekt} from './utils';

export {default as Subjekt} from './Subjekt';
export {formatSubjekt};
